<script setup lang="ts">
import { computed } from 'vue'

interface StoryStep {
  number: string
  title: string
  description: string
  image: string
  alt: string
}

const { imageUrls } = defineProps<{ imageUrls: [string, string, string] }>()

const steps = computed<StoryStep[]>(() => [
  {
    number: '01',
    title: '找到对应章节',
    description: '按教材目录快速定位，与课堂进度自然衔接。',
    image: imageUrls[0],
    alt: '凸透镜成像实验',
  },
  {
    number: '02',
    title: '阅读实验目的',
    description: '先理解需要验证的问题，再开始观察和操作。',
    image: imageUrls[1],
    alt: '蓝色液体扩散实验',
  },
  {
    number: '03',
    title: '开始动手探索',
    description: '自由调节条件、重复验证变化，让结果真正可理解。',
    image: imageUrls[2],
    alt: '条形磁铁磁场实验',
  },
])
</script>

<template>
  <section id="product" class="product-story section">
    <div class="manifesto">
      <div class="container">
        <p>理解，不止来自答案，也来自亲手验证的过程。</p>
      </div>
    </div>

    <div class="container story-grid">
      <article v-for="step in steps" :key="step.number" class="story-step">
        <span class="step-number">{{ step.number }}</span>
        <h2>{{ step.title }}</h2>
        <p>{{ step.description }}</p>
        <div class="story-image">
          <img v-if="step.image" :src="step.image" :alt="step.alt" loading="lazy" />
          <div v-else class="image-placeholder">流程展示图</div>
        </div>
      </article>
    </div>
  </section>
</template>
